<script setup lang="ts">
import type { IDashboardWidgetProps, TWidgetEmits } from '@tenorlab/vue-dashboard'
import { DashboardWidgetBase, Stack, ListItem, useWidgetEmits } from '@tenorlab/vue-dashboard'
import { smallCardClasses } from '@/components/shared'

const props = defineProps<IDashboardWidgetProps>()
const emits = defineEmits<TWidgetEmits>()
const emitHandlers = useWidgetEmits(emits)
</script>

<template>
  <DashboardWidgetBase
    v-bind="props"
    v-on="emitHandlers"
    :hideTitle="true"
    :noBorder="true"
    :noPadding="true"
    :noShadow="true"
    backgroundCssClasses="bg-transparent body-text-color"
  >
    <Stack testId="small-card-sample0" direction="column" classNames="bg-card content-card">
      <ListItem innerClass="p-4 border border-opacity-30 border-card-invert bg-cardchild">
        <div :class="smallCardClasses.outerDiv">
          <span :class="smallCardClasses.labelDiv">Small Card</span>
          <div :class="smallCardClasses.valueDiv">
            <span :class="smallCardClasses.valueLarge">5,877</span>
            <span :class="smallCardClasses.valueSmall">/store</span>
          </div>
          <div :class="smallCardClasses.dateDiv">
            <div :class="smallCardClasses.dateText">Nov 15, 2025 at 02:03am</div>
          </div>
        </div>
      </ListItem>
    </Stack>
  </DashboardWidgetBase>
</template>
